export default function IconButton() {
    return {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: 4
                },
                sizeLarge: {
                    fontSize: '1.25rem'
                },
                sizeMedium: {
                    fontSize: '1rem'
                },
                sizeSmall: {
                    fontSize: '0.75rem'
                }
            }
        }
    };
}
